export default class State {
  constructor(stateName) {
    this.stateName = stateName;
  }
}
